// eslint-disable-next-line no-undef
export default {
  phone: 576,
  tablet: 768,
  laptop: 992,
  notebook: 1200,
  desktop: 1400,
  //   sm: 576,
  //   md: 768,
  //   lg: 992,
  //   xl: 1200,
  //   xxl: 1400,
};
